module.exports = __webpack_public_path__ + "img/Annotated_Earth_Map.8333f5d2.png";